import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { AppDispatch, RootState } from '../../data/store';
import { logoutUser } from '../../data/thunks/authThunk';
import Menu from '../common/Menu';
import LogoutIcon from '@mui/icons-material/Logout';
import { useNavigate } from 'react-router-dom';
import BusinessIcon from '@mui/icons-material/Business';
import SettingsIcon from '@mui/icons-material/Settings';
import PortraitIcon from '@mui/icons-material/Portrait';
import Avatar from '../common/Avatar';
import { fetchAndUpdateProfilePicture } from '../../data/thunks/userThunk';
import { isAdmin } from '../../utils/auth-utils';

interface MenuItem {
	display: React.ReactNode | 'DIVIDER';
	onClick?: () => void;
	disabled?: boolean;
}

export default function UserNavItem() {
	const dispatch = useDispatch<AppDispatch>();
	const { user, astroToken } = useSelector(
		(state: RootState) => state.authState
	);
	const navigate = useNavigate();

	useEffect(() => {
		if (astroToken) {
			dispatch(fetchAndUpdateProfilePicture());
		}
	}, [astroToken]);

	const menuItems = useMemo<MenuItem[]>(() => {
		const items: MenuItem[] = [
			{
				display: (
					<div>
						{user?.firstName} {user?.lastName}
						<UserEmail>{user?.email}</UserEmail>
					</div>
				),
			},
			{ display: 'DIVIDER' },
		];
		if (isAdmin()) {
			items.push({
				display: (
					<DropDownItem>
						<BusinessIcon />
						My Company
					</DropDownItem>
				),
				onClick: () => navigate('/company'),
			});
		}
		items.push(
			{
				display: (
					<DropDownItem>
						<PortraitIcon />
						My Profile
					</DropDownItem>
				),
				onClick: () => navigate('/internal-onboarding'),
			},
			{
				display: (
					<DropDownItem>
						<SettingsIcon />
						Settings
					</DropDownItem>
				),
				onClick: () => navigate('/settings'),
			},
			{ display: 'DIVIDER' },
			{
				display: (
					<DropDownItem>
						<LogoutIcon />
						Sign out
					</DropDownItem>
				),
				onClick: () => dispatch(logoutUser()),
			}
		);
		return items;
	}, []);
	return (
		<UserContainer>
			<Menu
				// title={`${authState.user?.firstName} ${authState.user?.lastName}`}
				iconButton
				alternativeIcon={() => (
					<StyledAvatar
						src={user?.googleProfilePictureUrl}
						alt={`${user?.firstName} ${user?.lastName}`}
					>
						{!user?.googleProfilePictureUrl && (
							<>
								{user?.firstName[0]}
								{user?.lastName[0]}
							</>
						)}
					</StyledAvatar>
				)}
				menuItems={menuItems}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'right',
				}}
			/>
		</UserContainer>
	);
}

const UserContainer = styled('div')`
	display: flex;
	justify-content: flex-end;
	align-items: center;
`;

const DropDownItem = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
`;

const UserEmail = styled.div`
	font-size: 0.8rem;
	color: ${({ theme }) => theme.palette.text.subheader};
`;

const StyledAvatar = styled(Avatar)`
	font-size: 14px !important;
	height: 30px !important;
	width: 30px !important;
`;
